export function getdata() {
	var obj = {
		headData: [{
				title: "公司代码",
				prop: "companyCode",
				width: "80",
				custom: true

			},
			{
				title: "纳税人（公司）名称",
				prop: "nsrmc",
				width: 150,
				custom: true
				
			},
			{
				title: "纳税人识别号",
				prop: "nsrsbh",
				width: 160,
				custom: true
				
			},
			{
				title: "是否为报税主体",
				prop: "sfbszt",
				width: "120",
				custom: true
			},
			{
				title: "是否启用",
				prop: "sfyx",
				width: "80",
				custom: true
			},
			{
				title: "操作",
				prop: "cz",
				width: "250px",
				fixed: "right",
				custom: true
			}
		],
		tableData: [{}],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
